import { openMetadataApiClient } from '@/shared/api/core/axios-instance';

type DeleteGlossaryCategoryRequest = {
  glossaryId: string;
  recursive?: boolean;
  hardDelete?: boolean;
};

const deleteGlossaryCategoryApi = async ({
  glossaryId,
  recursive = true,
  hardDelete = true,
}: DeleteGlossaryCategoryRequest): Promise<void> => {
  try {
    await openMetadataApiClient.delete(`/glossaries/${encodeURIComponent(glossaryId)}`, {
      params: {
        recursive,
        hardDelete,
      },
    });
  } catch (error) {
    console.error('Failed to delete glossary category:', error);
    throw error;
  }
};

export type { DeleteGlossaryCategoryRequest };
export { deleteGlossaryCategoryApi };
